import { SupportType } from "@faire/help-center-utils/lib/dateInTimeZone";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

import { getSupportWorkingHours } from "../utils/timezone";

interface IOperatingTimeProps {
  color?: string | undefined;
  supportType: SupportType;
}

export const OperatingTime: React.FC<IOperatingTimeProps> = ({
  color,
  supportType,
}) => {
  const { formattedEndHours, formattedStartHours, formattedTimezone } =
    getSupportWorkingHours(supportType);

  if (!formattedStartHours || !formattedEndHours || !formattedTimezone) {
    return (
      <Typography variant="paragraphSansRegular" color={color}>
        <StrictLocalMsg
          defaultMessage="Mon-Fri, 9AM-8PM EST"
          description={{
            text: "describe the working time from morning 9 am to afternoon 8 pm in EST timezone",
            img: "https://cdn.faire.com/fastly/5963b85a3bca2f9f8013d515698d7ae2d6da21a059b4a2e59273bdeba6f04e2e.png",
          }}
        />
      </Typography>
    );
  }

  return (
    <Typography variant="paragraphSansRegular" color={color}>
      <StrictLocalMsg
        defaultMessage="Mon-Fri, {StartTime}AM-{EndTime}PM {TimeZoneTime}"
        description={{
          text: "describe the chat or phone working time, for example, from Mon-Fri, 9AM-5PM EST",
          img: "https://cdn.faire.com/fastly/5963b85a3bca2f9f8013d515698d7ae2d6da21a059b4a2e59273bdeba6f04e2e.png",
        }}
        values={{
          StartTime: formattedStartHours,
          EndTime: formattedEndHours,
          TimeZoneTime: formattedTimezone,
        }}
      />
    </Typography>
  );
};
